import React, { SVGProps } from "react";

const Icon: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      width="200"
      height="75.04"
      viewBox="0 0 200.000000 75.04"
      preserveAspectRatio="xMidYMid meet"
      color-interpolation-filters="sRGB"
      {...props}
    >
      <defs>
        <linearGradient id="92" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#fa71cd" />
          <stop offset="100%" stopColor="#9b59b6" />
        </linearGradient>
        <linearGradient id="93" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#f9d423" />
          <stop offset="100%" stopColor="#f83600" />
        </linearGradient>
        <linearGradient id="94" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#0064d2" />
          <stop offset="100%" stopColor="#1cb0f6" />
        </linearGradient>
        <linearGradient id="95" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#f00978" />
          <stop offset="100%" stopColor="#3f51b1" />
        </linearGradient>
        <linearGradient id="96" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#7873f5" />
          <stop offset="100%" stopColor="#ec77ab" />
        </linearGradient>
        <linearGradient id="97" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#f9d423" />
          <stop offset="100%" stopColor="#e14fad" />
        </linearGradient>
        <linearGradient id="98" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#009efd" />
          <stop offset="100%" stopColor="#2af598" />
        </linearGradient>
        <linearGradient id="99" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#ffcc00" />
          <stop offset="100%" stopColor="#00b140" />
        </linearGradient>
        <linearGradient id="100" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#d51007" />
          <stop offset="100%" stopColor="#ff8177" />
        </linearGradient>
        <linearGradient id="102" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#a2b6df" />
          <stop offset="100%" stopColor="#0c3483" />
        </linearGradient>
        <linearGradient id="103" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#7ac5d8" />
          <stop offset="100%" stopColor="#eea2a2" />
        </linearGradient>
        <linearGradient id="104" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#00ecbc" />
          <stop offset="100%" stopColor="#007adf" />
        </linearGradient>
        <linearGradient id="105" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#b88746" />
          <stop offset="100%" stopColor="#fdf5a6" />
        </linearGradient>
      </defs>
      <g fill={props.color}>
        <g>
          <rect fill-opacity="0" stroke-width="2" x="0" y="0" width="60"
            height="75.04033417962155" />
          <svg x="0" y="0" width="60" height="75.04033417962155"
            style={{ overflow: 'visible' }}>
            <svg xmlns="http://www.w3.org/2000/svg"
              viewBox="-1.98723 -2 27.98723 34" version="1.1" x="0px" y="0px">
              <path
                d="M21,30 L9,30 C8.447,30 8,29.552 8,29 C8,27.462 7.266,26.572 6.153,25.226 C5.536,24.479 4.838,23.633 4.15,22.528 C2.256,19.48 0.617,15.979 0.21,14.604 C-0.186,13.264 0.08,12.402 0.432,11.931 C0.88,11.331 1.615,11 2.5,11 C3.669,11 4.947,12.004 6,13.301 L6,3 C6,1.346 7.346,0 9,0 C10.654,0 12,1.346 12,3 L12,7.171 C12.313,7.06 12.649,7 13,7 C14.061,7 14.994,7.553 15.528,8.386 C15.963,8.141 16.466,8 17,8 C18.381,8 19.548,8.939 19.895,10.211 C20.237,10.075 20.61,10 21,10 C22.654,10 24,11.346 24,13 L24,16 C24,18.551 23.479,20.659 22.976,22.697 C22.474,24.728 22,26.645 22,29 C22,29.552 21.553,30 21,30 L21,30 Z M9.924,28 L20.026,28 C20.138,25.844 20.593,24.004 21.034,22.217 C21.531,20.207 22,18.308 22,16 L22,12.8 C22,12.249 21.552,11.8 21,11.8 C20.448,11.8 20,12.249 20,12.8 L20,14 C20,14.552 19.553,15 19,15 C18.447,15 18,14.552 18,14 L18,10.8 C18,10.249 17.552,9.8 17,9.8 C16.448,9.8 16,10.249 16,10.8 L16,13 C16,13.552 15.553,14 15,14 C14.447,14 14,13.552 14,13 L14,9.8 C14,9.249 13.552,8.8 13,8.8 C12.448,8.8 12,9.249 12,9.8 L12,12 C12,12.552 11.553,13 11,13 C10.447,13 10,12.552 10,12 L10,2.8 C10,2.249 9.552,1.8 9,1.8 C8.448,1.8 8,2.249 8,2.8 L8,18 C8,18.552 7.553,19 7,19 C6.447,19 6,18.552 6,18 L6,17.179 C5.121,14.877 3.164,12.9 2.5,12.9 C2.268,12.9 2.109,12.953 2.033,13.128 C1.977,13.259 1.923,13.561 2.058,14.018 C2.371,15.075 3.901,18.338 5.85,21.472 C6.466,22.463 7.091,23.22 7.695,23.952 C8.737,25.213 9.659,26.33 9.924,28 L9.924,28 Z" />
            </svg>
          </svg>
          <defs>
            <filter id="colors8286393985">
              <feColorMatrix type="matrix" values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 1 0"
              />
            </filter>
            <filter id="colorsf2498645968">
              <feColorMatrix type="matrix"
                values="0 0 0 0 0.99609375  0 0 0 0 0.99609375  0 0 0 0 0.99609375  0 0 0 1 0"
              />
            </filter>
            <filter id="colorsb8515254768">
              <feColorMatrix type="matrix" values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 1 0"
              />
            </filter>
          </defs>
        </g>

        <g transform="translate(67,14.667427062988281)">
          <g fill-rule="" >
            <g transform="scale(1)">
              <g>
                <path
                  d="M6.77 0L1.63 0 1.63-20.58 11.92-20.58Q15.56-20.58 17.29-18.66 19.01-16.75 19.01-13.52L19.01-13.52Q19.01-11.44 17.96-9.87 16.91-8.31 15.08-7.54L15.08-7.54Q15.53-7.19 15.8-6.76 16.07-6.33 16.39-5.56L16.39-5.56 18.82 0 13.45 0 11.15-5.24Q10.87-5.91 10.42-6.22 9.97-6.52 9.14-6.52L9.14-6.52 6.77-6.52 6.77 0ZM6.77-16.62L6.77-10.48 10.58-10.48Q12.08-10.48 12.93-11.23 13.77-11.98 13.77-13.52L13.77-13.52Q13.77-16.62 10.8-16.62L10.8-16.62 6.77-16.62ZM36.81 0L21.63 0 21.63-20.58 36.81-20.58 36.81-16.62 26.78-16.62 26.78-12.3 35.63-12.3 35.63-8.28 26.78-8.28 26.78-3.96 36.81-3.96 36.81 0ZM49.53 0.32L49.53 0.32Q44.2 0.32 41.42-2.38 38.64-5.08 38.64-10L38.64-10Q38.64-15.15 41.48-18.02 44.32-20.9 49.85-20.9L49.85-20.9Q51.74-20.9 53.26-20.68 54.77-20.45 56.15-20L56.15-20 56.15-15.59Q54.77-16.11 53.29-16.3 51.8-16.49 50.24-16.49L50.24-16.49Q46.91-16.49 45.39-14.91 43.88-13.33 43.88-10L43.88-10Q43.88-6.97 45.31-5.51 46.75-4.06 49.56-4.06L49.56-4.06Q51.42-4.06 53.02-4.57L53.02-4.57 53.02-8.47 48.57-8.47 48.57-11.7 57.33-11.7 57.33-1.5Q56.24-0.8 54.31-0.24 52.38 0.32 49.53 0.32ZM65.1 0L59.95 0 59.95-20.58 65.1-20.58 65.1 0ZM73.5 0L68.36 0 68.36-20.58 73.44-20.58 79.03-9.17 84.59-20.58 89.64-20.58 89.64 0 84.49 0 84.49-11.82 80.44-3.52 77.59-3.52 73.5-11.82 73.5 0ZM108.08 0L92.9 0 92.9-20.58 108.08-20.58 108.08-16.62 98.04-16.62 98.04-12.3 106.9-12.3 106.9-8.28 98.04-8.28 98.04-3.96 108.08-3.96 108.08 0ZM115.68 0L110.54 0 110.54-20.58 114.95-20.58 123.7-8.28 123.7-20.58 128.88-20.58 128.88 0 124.44 0 115.68-12.27 115.68 0Z"
                  transform="translate(-1.6299999952316284, 20.899999618530273)" />
              </g>
              <g fill={props.color} transform="translate(0,24.219999313354492)">
                <g transform="scale(0.99562)">
                  <path
                    d="M13.23 0L1.68 0 1.68-21.25 12.9-21.25Q16.1-21.25 17.73-19.73 19.37-18.21 19.37-15.44L19.37-15.44Q19.37-13.76 18.72-12.62 18.08-11.48 17.02-10.85L17.02-10.85Q18.47-10.33 19.3-9.3 20.12-8.28 20.12-6.24L20.12-6.24Q20.12-3.2 18.34-1.6 16.56 0 13.23 0L13.23 0ZM6.99-17.42L6.99-12.6 11.32-12.6Q12.7-12.6 13.33-13.23 13.96-13.86 13.96-14.98L13.96-14.98Q13.96-16.2 13.33-16.81 12.7-17.42 11.05-17.42L11.05-17.42 6.99-17.42ZM6.99-8.94L6.99-3.79 11.84-3.79Q13.3-3.79 14-4.39 14.71-4.98 14.71-6.5L14.71-6.5Q14.71-7.72 14.02-8.33 13.33-8.94 11.65-8.94L11.65-8.94 6.99-8.94ZM32.43 0.33L32.43 0.33Q29.46 0.33 27.27-0.63 25.07-1.58 23.87-3.46 22.66-5.34 22.66-8.08L22.66-8.08 22.66-21.25 27.98-21.25 27.98-8.58Q27.98-6.37 29.13-5.28 30.29-4.19 32.43-4.19L32.43-4.19Q34.57-4.19 35.73-5.28 36.88-6.37 36.88-8.58L36.88-8.58 36.88-21.25 42.2-21.25 42.2-8.08Q42.2-5.34 40.99-3.46 39.79-1.58 37.59-0.63 35.4 0.33 32.43 0.33ZM50.71 0L45.4 0 45.4-21.25 50.71-21.25 50.71 0ZM69.41 0L54.07 0 54.07-21.25 59.38-21.25 59.38-4.09 69.41-4.09 69.41 0ZM80.66 0L71.46 0 71.46-21.25 80.66-21.25Q83.9-21.25 86.11-20.17 88.32-19.1 89.47-16.74 90.63-14.38 90.63-10.49L90.63-10.49Q90.63-5.01 88.1-2.51 85.58 0 80.66 0L80.66 0ZM76.77-17.16L76.77-4.09 79.94-4.09Q81.65-4.09 82.82-4.6 83.99-5.11 84.6-6.5 85.22-7.88 85.22-10.49L85.22-10.49Q85.22-13.13 84.67-14.57 84.13-16 82.96-16.58 81.78-17.16 79.94-17.16L79.94-17.16 76.77-17.16ZM109 0L93.33 0 93.33-21.25 109-21.25 109-17.16 98.64-17.16 98.64-12.7 107.78-12.7 107.78-8.54 98.64-8.54 98.64-4.09 109-4.09 109 0ZM116.85 0L111.54 0 111.54-21.25 122.16-21.25Q125.93-21.25 127.71-19.27 129.49-17.29 129.49-13.96L129.49-13.96Q129.49-11.81 128.4-10.19 127.31-8.58 125.43-7.79L125.43-7.79Q125.89-7.42 126.17-6.98 126.45-6.53 126.78-5.74L126.78-5.74 129.29 0 123.75 0 121.37-5.41Q121.08-6.1 120.61-6.42 120.15-6.73 119.29-6.73L119.29-6.73 116.85-6.73 116.85 0ZM116.85-17.16L116.85-10.82 120.78-10.82Q122.33-10.82 123.2-11.6 124.08-12.37 124.08-13.96L124.08-13.96Q124.08-17.16 121.01-17.16L121.01-17.16 116.85-17.16Z"
                    transform="translate(-1.6799999475479126, 21.25)" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <defs v-gra="od" />
    </svg>
  );
};

export default React.memo(Icon);
